import {isFeatureEnabled} from '@github-ui/feature-flags'
import type {MobileOS} from '@github-ui/get-os'

export const MOBILE_EMAIL_HANDOFF_FEATURE_FLAG = 'site_github_app_mobile_email_handoff'
export const MOBILE_NATIVE_SHARE_FEATURE_FLAG = 'site_github_app_mobile_native_share'

type MobileCtaTreatment = 'emailHandoff' | 'nativeShare' | undefined

type MobileCtaTreatmentOptions = {
  hasEmailHandoffExperience: boolean
  hasNativeShareExperience: boolean
  mobileEmailHandoffEndpoint?: string
  mobilePlatform?: MobileOS
}

export function isMobileEmailHandoffProductionEnabled(featureEnabled: boolean, endpoint?: string): boolean {
  return featureEnabled && Boolean(endpoint?.trim())
}

export function getMobileCtaTreatment({
  hasEmailHandoffExperience,
  hasNativeShareExperience,
  mobileEmailHandoffEndpoint,
  mobilePlatform,
}: MobileCtaTreatmentOptions): MobileCtaTreatment {
  if (!mobilePlatform) return undefined

  if (hasNativeShareExperience || isFeatureEnabled(MOBILE_NATIVE_SHARE_FEATURE_FLAG)) return 'nativeShare'

  if (
    hasEmailHandoffExperience ||
    isMobileEmailHandoffProductionEnabled(
      isFeatureEnabled(MOBILE_EMAIL_HANDOFF_FEATURE_FLAG),
      mobileEmailHandoffEndpoint,
    )
  ) {
    return 'emailHandoff'
  }

  return undefined
}
